// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicClientsListCard } from "./plasmic/collect_wise_draft/PlasmicClientsListCard";
import { useNavigate } from 'react-router-dom';

function MasterClientsListCard_(props, ref) {
  const navigate = useNavigate()

  return <PlasmicClientsListCard root={{ ref,
  onClick: () => navigate(`masterviewdebtor/${props.id}`)
  }} {...props} />;
}


const MasterClientsListCard = React.forwardRef(MasterClientsListCard_);

export default MasterClientsListCard;
